import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { MantenimientoProductosComponent } from './modules/gestion/components/mantenimiento-productos/mantenimiento-productos.component';
import { MantenimientoMarcasComponent } from './modules/gestion/components/mantenimiento-marcas/mantenimiento-marcas.component';
import { HomeComponent } from './modules/home/home.component';
import { MantenimientoPaisesComponent } from './modules/admin/components/mantenimiento-paises/mantenimiento-paises.component';
import { MantenimientoCampanyasComponent } from './modules/gestion/components/mantenimiento-campañas/mantenimiento-campanyas.component';
import { MantenimientoMunicipiosComponent } from './modules/admin/components/mantenimiento-municipios/mantenimiento-municipios.component';
import { MantenimientoEtiquetadoresComponent } from './modules/etiquetado/components/mantenimiento-etiquetadores/mantenimiento-etiquetadores.component';
import { MantenimientoDenominacionesComponent } from './modules/gestion/components/mantenimiento-denominaciones/mantenimiento-denominaciones.component';
import { EtiquetadoresComponent } from './modules/usuarios/components/etiquetadores/etiquetadores.component';
import { MantenimientoCultivosComponent } from './modules/cultivos/components/mantenimiento-cultivos/mantenimiento-cultivos.component';
import { GestionLicenciasComponent } from './modules/admin/components/gestion-licencias/gestion-licencias.component';
import { MantenimientoDesignacionesComponent } from './modules/etiquetado/components/mantenimiento-designaciones/mantenimiento-designaciones.component';
import { MantenimientoEnvasesComponent } from './modules/etiquetado/components/mantenimiento-envases/mantenimiento-envases.component';
import { MantenimientoConfeccionesComponent } from './modules/etiquetado/components/mantenimiento-confecciones/mantenimiento-confecciones.component';
import { ConsumosComponent } from './modules/etiquetado/components/consumos/consumos.component';
import { EtiquetadoComponent } from './modules/etiquetado/components/etiquetado/etiquetado.component';
import { ReetiquetadoComponent } from './modules/etiquetado/components/reetiquetado/reetiquetado.component';
import { TotalesComponent } from './modules/etiquetado/components/totales/totales.component';
import { MantenimientoIncidenciasComponent } from './modules/etiquetado/components/mantenimiento-incidencias/mantenimiento-incidencias.component';
import { DashEtiquetadoresComponent } from './modules/dashboards/components/dash-etiquetadores/dash-etiquetadores.component';
import { MantenimientoDisenyoEtiquetasComponent } from './modules/configuracion/components/disenenyo-etiquetas/disenyo-etiquetas.component';
import { HistoricoCultivosComponent } from './modules/historico/components/historico-cultivos/historico-cultivos.component';
import { HistoricoDesignacionesComponent } from './modules/historico/components/historico-designaciones/historico-designaciones.component';
import { HistoricoConsumosComponent } from './modules/historico/components/historico-consumos/historico-consumos.component';
import { HistoricoEtiquetadoComponent } from './modules/historico/components/historico-etiquetado/historico-etiquetado.component';
import { HistoricoReetiquetadoComponent } from './modules/historico/components/historico-reetiquetado/historico-reetiquetado.component';
import { HistoricoTotalesComponent } from './modules/historico/components/historico-totales/historico-totales.component';
import { MantenimientoEtiquetasComponent } from './modules/configuracion/components/mantenimiento-etiquetas/mantenimiento-etiquetas.component';
import { MantenimientoEntidadesControlComponent } from './modules/admin/components/mantenimiento-entidades-control/mantenimiento-entidades-control.component';
import { AuditoresComponent } from './modules/usuarios/components/auditores/auditores.component';
import { CultivosComponent } from './modules/etiquetado/components/cultivos/cultivos.component';
import { TrazabilidadEtiquetaComponent } from './modules/etiquetado/components/trazabilidad-etiqueta/trazabilidad-etiqueta.component';
import { CentralAvisosComponent } from './modules/data/components/central-avisos/central-avisos.component';
import { EdicionPoligonosComponent } from './modules/cultivos/components/app-edicion-poligonos/app-edicion-poligonos.component';
import { DashCultivosComponent } from './modules/dashboards/components/dash-cultivos/dash-cultivos.component';
import { CentralEstadisticasComponent } from './modules/data/components/central-estadisticas/central-estadisticas.component';
import { UsuariosComponent } from './modules/usuarios/components/usuarios/usuarios.component';
import { LogsComponent } from './modules/admin/components/logs/logs.component';
import { ProductoresComponent } from './modules/cultivos/components/productores/productores.component';
import { ConfiguradorConsumosComponent } from './modules/configuracion/components/configurador-consumos-integracion/configurador-consumos-integracion.component';
import { DashDesignacionesComponent } from './modules/dashboards/components/dash-designaciones/dash-designaciones.component';
import { ConfeccionesDuplicarComponent } from './modules/etiquetado/components/confecciones-duplicar/confecciones-duplicar.component';
import { ViewerPdfComponent } from 'projects/shared-components/src/lib/components/viewer-pdf/viewer-pdf.component';
import { MantenimientoRoyaltiesComponent } from './modules/royalties/components/mantenimiento-royalties/mantenimiento-royalties.component';
import { GestionRoyaltiesComponent } from './modules/royalties/components/gestion-royalties/gestion-royalties.component';
import { RegistroActividadComponent } from './modules/admin/components/registro-actividad/registro-actividad.component';
import { DashRoyaltiesComponent } from './modules/dashboards/components/dash-royalties/dash-royalties.component';
import { MantenimientoVersionesEtiquetadoComponent } from './modules/admin/components/mantenimiento-versiones-etiquetado/mantenimiento-versiones-etiquetado.component';
import { CentralNotificacionesComponent } from './modules/admin/components/central-notificaciones/central-notificaciones.component';
import { CsvLogsComponent } from './modules/admin/components/csv-logs/csv-logs.component';
import { MantenimientoCertificadosComponent } from './modules/expediciones/components/mantenimiento-certificados/mantenimiento-certificados.component';
import { MantenimientoExpedicionesComponent } from './modules/expediciones/components/mantenimiento-expediciones/mantenimiento-expediciones.component';
import { TrazabilidadCertificadoComponent } from './modules/expediciones/components/trazabilidad-certificado/trazabilidad-certificado.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'trz',
    component: TrazabilidadEtiquetaComponent
  },
  {
    path: 'viewPdf',
    component: ViewerPdfComponent
  },
  {
    path: 'admin',
    children: [
      {
        path: 'mantenimiento-paises',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_PSS'
        },
        component: MantenimientoPaisesComponent
      },
      {
        path: 'mantenimiento-municipios',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_MNC'
        },
        component: MantenimientoMunicipiosComponent
      },
      {
        path: 'mantenimiento-entidades-control',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_MEC'
        },
        component: MantenimientoEntidadesControlComponent
      },
      {
        path: 'ges-licencias',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_LIC'
        },
        component: GestionLicenciasComponent
      },
      // {
      //   path: 'ges-royalties',
      //   canActivate: [AuthGuard],
      //   data: {
      //     claim: 'ROY_List'
      //   },
      //   component: GestionRoyaltiesComponent
      // },
      {
        path: 'logs',
        canActivate: [AuthGuard],
        data: {
          claim: null
        },
        component: LogsComponent
      },
      {
        path: 'csv-logs',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CSV'
        },
        component: CsvLogsComponent
      },
      {
        path: 'registro-actividad',
        canActivate: [AuthGuard],
        data: {
          claim: null,
        },
        component: RegistroActividadComponent
      },
      {
        path: 'versiones-etiquetado',
        canActivate: [AuthGuard],
        data: {
          claim: null
        },
        component: MantenimientoVersionesEtiquetadoComponent
      },
      {
        path: 'central-notificaciones',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CNO'
        },
        component: CentralNotificacionesComponent
      }
    ]
  },
  {
    path: 'dashboards',
    children: [
      {
        path: 'etiquetadores',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_DEQ'
        },
        component: DashEtiquetadoresComponent
      },
      {
        path: 'cultivos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_DCV'
        },
        component: DashCultivosComponent
      },
      {
        path: 'designaciones',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_DDS'
        },
        component: DashDesignacionesComponent
      },
      {
        path: 'royalties',
        canActivate: [AuthGuard],
        data: {
          claim: 'DSH_Royalty'
        },
        component: DashRoyaltiesComponent
      }
    ]
  },
  {
    path: 'cultivos',
    children: [
      {
        path: 'mantenimiento-cultivos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_MCV'
        },
        component: MantenimientoCultivosComponent
      },
      {
        path: 'productores',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_PRO'
        },
        component: ProductoresComponent
      },
      {
        path: 'edicion-poligonos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_EDP'
        },
        component: EdicionPoligonosComponent
      },
    ]
  },
  {
    path: 'gestion',
    children: [
      {
        path: 'mantenimiento-marcas',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_MRC'
        },
        component: MantenimientoMarcasComponent
      },
      {
        path: 'mantenimiento-productos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_PRD'
        },
        component: MantenimientoProductosComponent
      },
      {
        path: 'mantenimiento-campanyas',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CMP'
        },
        component: MantenimientoCampanyasComponent
      },
      {
        path: 'mantenimiento-denominaciones',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_DNM'
        },
        component: MantenimientoDenominacionesComponent
      },

    ]
  },
  {
    path: 'etiquetado',
    children: [
      {
        path: 'mantenimiento-etiquetadores',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_ETD'
        },
        component: MantenimientoEtiquetadoresComponent
      },
      {
        path: 'mantenimiento-designaciones',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_DSG'
        },
        component: MantenimientoDesignacionesComponent
      },
      {
        path: 'mantenimiento-envases',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_MEV'
        },
        component: MantenimientoEnvasesComponent
      },
      {
        path: 'mantenimiento-confecciones',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_MCF'
        },
        component: MantenimientoConfeccionesComponent
      },
      {
        path: 'confecciones-duplicar',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_DCF'
        },
        component: ConfeccionesDuplicarComponent
      },
      {
        path: 'consumos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CNS'
        },
        component: ConsumosComponent
      },
      {
        path: 'etiquetado',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_ETQ'
        },
        component: EtiquetadoComponent
      },
      {
        path: 'reetiquetado',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_RTQ'
        },
        component: ReetiquetadoComponent
      },
      {
        path: 'totales',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_TOT'
        },
        component: TotalesComponent
      },
      {
        path: 'mantenimiento-incidencias',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_INC'
        },
        component: MantenimientoIncidenciasComponent
      },
      {
        path: 'informe-cultivos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_ICV'
        },
        component: CultivosComponent
      },
      {
        path: 'trazabilidad-etiqueta',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_TRZ'
        },
        component: TrazabilidadEtiquetaComponent
      }
    ]
  },
  {
    path: 'expediciones',
    children: [
      {
        path: 'mantenimiento-expediciones',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_EXP'
        },
        component: MantenimientoExpedicionesComponent
      },
      {
        path: 'mantenimiento-certificados',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CEX'
        },
        component: MantenimientoCertificadosComponent
      },
      {
        path: 'trazabilidad-certificado',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CET'
        },
        component: TrazabilidadCertificadoComponent
      },
    ]
  },
  {
    path: 'historico',
    children: [
      {
        path: 'historico-cultivos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_HCV'
        },
        component: HistoricoCultivosComponent
      },
      {
        path: 'historico-designaciones',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_HDS'
        },
        component: HistoricoDesignacionesComponent
      },
      {
        path: 'historico-consumos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_HCS'
        },
        component: HistoricoConsumosComponent
      },
      {
        path: 'historico-etiquetado',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_HET'
        },
        component: HistoricoEtiquetadoComponent
      },
      {
        path: 'historico-reetiquetado',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_HRT'
        },
        component: HistoricoReetiquetadoComponent
      },
      {
        path: 'historico-totales',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_HTT'
        },
        component: HistoricoTotalesComponent
      },
    ]
  },
  {
    path: 'royalties',
    children: [
      {
        path: 'mantenimiento-royalties',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_COR'
        },
        component: MantenimientoRoyaltiesComponent
      },
      {
        path: 'ges-royalties',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_ROY'
        },
        component: GestionRoyaltiesComponent
      },
    ]
  },
  {
    path: 'configuracion',
    children: [
      {
        path: 'mantenimiento-etiquetas',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_MET'
        },
        component: MantenimientoEtiquetasComponent
      },
      {
        path: 'disenyo-etiquetas',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_DET'
        },
        component: MantenimientoDisenyoEtiquetasComponent
      },
      {
        path: 'configurador-consumos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CIC'
        },
        component: ConfiguradorConsumosComponent
      },
      // {
      //   path: 'mantenimiento-royalties',
      //   canActivate: [AuthGuard],
      //   data: {
      //     claim: 'ROY_List'
      //   },
      //   component: MantenimientoRoyaltiesComponent
      // }
    ]
  },
  {
    path: 'usuarios',
    children: [
      {
        path: 'usuarios',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_USU'
        },
        component: UsuariosComponent
      },
      {
        path: 'etiquetadores',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_EQS'
        },
        component: EtiquetadoresComponent
      },
      {
        path: 'auditores',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_AUD'
        },
        component: AuditoresComponent
      }
    ]
  },
  {
    path: 'data',
    children: [
      {
        path: 'central-avisos',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CAV'
        },
        component: CentralAvisosComponent
      },
      {
        path: 'central-estadisticas',
        canActivate: [AuthGuard],
        data: {
          claim: 'D_CES'
        },
        component: CentralEstadisticasComponent
      },
    ]
  },
  // ESTE PATH DEBE IR SIEMPRE EN ÚLTIMO LUGAR.
  // Redirect por defecto para cualquier path no contenido en este fichero.
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
